import { useRef } from "react";

/** Keep local editor drafts attached to their row across deletion and key renaming. */
export function useConfigurationRowIds() {
  const ids = useRef(new Map<string, number>());
  const nextId = useRef(0);
  return {
    key(name: string) {
      if (!ids.current.has(name)) ids.current.set(name, nextId.current++);
      return ids.current.get(name)!;
    },
    rename(before: string, after: string) {
      const id = ids.current.get(before);
      ids.current.delete(before);
      if (id !== undefined) ids.current.set(after, id);
    },
    remove(name: string) { ids.current.delete(name); },
    removeIndex(index: number, length: number) {
      for (let i = index; i < length - 1; i++) {
        const id = ids.current.get(String(i + 1));
        if (id !== undefined) ids.current.set(String(i), id);
      }
      ids.current.delete(String(length - 1));
    },
  };
}
